import React from 'react'
import { Route, Switch } from 'react-router-dom'
import globals from '../globals'
import SubNavigation from '../modules/SubNavigation'
import FaqModule from '../modules/FaqModule'
import {
    NETWORK_OPTUS,
    NETWORK_TELSTRA,
    SERVICE_FIBRE,
    SERVICE_MOBILE,
    SERVICE_MOBILE_BROADBAND,
    SERVICE_NBN,
    SERVICE_WIRELESS
} from '../constants'
import { connect } from 'react-redux'

class Faqs extends React.Component {
    constructor (props) {
        super(props)

        this.subNav = [
            { title: 'General', url: '' },
            { title: 'nbn&trade;', url: '/nbn' },
            { title: 'Fibre', url: '/fibre' },
            { title: 'Home Secure', url: '/home-secure' },
            { title: 'Mobile Broadband', url: '/mobile-broadband' },
            { title: 'Mobile SIM Plans<br />(Optus Network)', url: '/mobile-optus' },
            { title: 'Mobile SIM Plans<br />(Telstra Network)', url: '/mobile-telstra' },
            { title: 'Home Wireless Broadband', url: '/wireless' },
            { title: 'Fixed broadband billing', url: '/fixed-broadband-billing' },
            { title: 'Mobile services billing', url: '/mobile-services-billing' }
        ]
    }

    componentDidMount () {
        globals.animatePageIn(this.container)
    }

    render () {
        const RenderGeneral = () => {
            return <FaqModule type='general' title='General FAQs' />
        }

        const RenderNbn = () => {
            return <FaqModule type={SERVICE_NBN} title='nbn&trade; FAQs' />
        }

        const RenderFibre = () => {
            return <FaqModule type={SERVICE_FIBRE} title='Fibre FAQs' />
        }

        const RenderWireless = () => {
            return <FaqModule type={SERVICE_WIRELESS} title='Home Wireless Broadband FAQs' />
        }

        const RenderOptus = () => {
            return <FaqModule type={NETWORK_OPTUS.toLowerCase()} title='Mobile SIM Plans FAQs (Optus Network)' />
        }

        const RenderTelstra = () => {
            return <FaqModule type={NETWORK_TELSTRA.toLowerCase()} title='Mobile SIM Plans FAQs (Telstra Network)' />
        }

        const RenderMobileBroadband = () => {
            return <FaqModule type={SERVICE_MOBILE_BROADBAND} title='Mobile Broadband FAQs' />
        }

        const RenderHomeSecure = () => {
            return <FaqModule type='homeSecure' title='Home Secure FAQs' />
        }

        const RenderFixedBroadbandBilling = () => {
            return <FaqModule type='fixedBroadbandBilling' title='Fixed broadband billing FAQs' />
        }

        const RenderMobileServicesBilling = () => {
            return <FaqModule type='mobileServicesBilling' title='Mobile services billing FAQs' />
        }

        return (
            <div ref={(el) => this.container = el} style={{ opacity: 0 }}>
                <SubNavigation
                    title='Find our FAQs below'
                    items={this.subNav}
                    url={this.props.match.url}
                    className='gtm-faq-section flex-basis-20'
                />

                <Switch>
                    <Route exact path={this.props.match.url} component={RenderGeneral} />
                    <Route exact path={`${this.props.match.url}/nbn`} component={RenderNbn} />
                    <Route exact path={`${this.props.match.url}/fibre`} component={RenderFibre} />
                    <Route exact path={`${this.props.match.url}/wireless`} component={RenderWireless} />
                    <Route exact path={`${this.props.match.url}/mobile-optus`} component={RenderOptus} />
                    <Route exact path={`${this.props.match.url}/mobile-telstra`} component={RenderTelstra} />
                    <Route exact path={`${this.props.match.url}/mobile-broadband`} component={RenderMobileBroadband} />
                    <Route exact path={`${this.props.match.url}/home-secure`} component={RenderHomeSecure} />
                    <Route exact path={`${this.props.match.url}/fixed-broadband-billing`} component={RenderFixedBroadbandBilling} />
                    <Route exact path={`${this.props.match.url}/mobile-services-billing`} component={RenderMobileServicesBilling} />
                </Switch>
            </div>
        )
    }
}

export default Faqs



// WEBPACK FOOTER //
// ./resources/js/pages/Faqs.js